import { Card, InputNumber, Select, Space } from 'antd';
import type { ArticleRow } from '../../api/client';

interface Props {
  pages: ArticleRow[];
  currentId: string;
  parentId: string | null;
  menuOrder: number | null;
  onParent: (id: string | null) => void;
  onMenuOrder: (n: number | null) => void;
}

/** 頁面（kind=page）專用設定：父頁面 + 選單排序（取代分類/標籤）。 */
export default function PageSettingsCard({
  pages,
  currentId,
  parentId,
  menuOrder,
  onParent,
  onMenuOrder,
}: Props) {
  return (
    <Card title="頁面設定">
      <Space direction="vertical" className="w-full">
        <Select
          allowClear
          className="w-full"
          placeholder="父頁面（無＝頂層）"
          value={parentId ?? undefined}
          onChange={(v) => onParent(v ?? null)}
          options={pages
            .filter((p) => p.id !== currentId)
            .map((p) => ({ value: p.id, label: p.title }))}
        />
        <InputNumber
          className="w-full"
          placeholder="選單排序（數字小者在前）"
          value={menuOrder ?? undefined}
          onChange={(v) => onMenuOrder(v ?? null)}
        />
      </Space>
    </Card>
  );
}
